// Alert rules (error-spike thresholds, destinations, tuning) are configured
// in the Sentry dashboard for the `tdm-web` project. See
// `docs/sentry-alerts.md` for the rule definitions and how to re-tune them.
import * as Sentry from "@sentry/react";

export function initSentry(): void {
  const dsn = import.meta.env["VITE_SENTRY_DSN"] as string | undefined;
  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    release: (import.meta.env["VITE_SENTRY_RELEASE"] as string | undefined) ?? "unknown",
    environment: import.meta.env["MODE"] ?? "development",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0,
    beforeSend(event) {
      if (event.request?.headers) {
        const headers = event.request.headers as Record<string, unknown>;
        delete headers["authorization"];
        delete headers["cookie"];
        delete headers["set-cookie"];
      }
      if (event.request?.cookies) {
        event.request.cookies = {};
      }
      return event;
    },
  });
}

export { Sentry };
